import type {
  CustomerMrrByMonth,
  MrrMovementChartDataPoint,
  WaterfallChartData,
} from './types';

export function computeBeginningMrr(
  selectedMonthKeys: string[],
  customerMrrByMonth: CustomerMrrByMonth,
  allMonthKeys: string[],
): number {
  if (selectedMonthKeys.length === 0) {
    return 0;
  }

  const firstSelected = selectedMonthKeys[0];
  const priorIndex = allMonthKeys.indexOf(firstSelected) - 1;

  if (priorIndex < 0) {
    return 0;
  }

  const priorMonthKey = allMonthKeys[priorIndex];

  let total = 0;
  for (const monthlyMrr of customerMrrByMonth.values()) {
    total += monthlyMrr.get(priorMonthKey) ?? 0;
  }
  return total;
}

export function buildWaterfallForRange(
  monthlyPoints: MrrMovementChartDataPoint[],
  beginning: number,
  label: string,
): WaterfallChartData {
  const totals = monthlyPoints.reduce(
    (acc, point) => ({
      new: acc.new + point.new,
      expansion: acc.expansion + point.expansion,
      reactivation: acc.reactivation + point.reactivation,
      contraction: acc.contraction + point.contraction,
      churn: acc.churn + point.churn,
    }),
    { new: 0, expansion: 0, reactivation: 0, contraction: 0, churn: 0 },
  );

  const ending =
    beginning
    + totals.new
    + totals.expansion
    + totals.reactivation
    + totals.contraction
    + totals.churn;

  return { label, beginning, ...totals, ending };
}
